import { MapMode, MapboxLayer, useHazardsStore, useMapStore } from '@/features';

/**
 * This is required to ensure the map layers are updated with the latest fire ban data.
 */
export const updateActiveFireBanLGAs = () => {
  const hazardsStore = useHazardsStore();
  if (hazardsStore.mapMode !== MapMode.FireBan) {
    return;
  }

  const map = useMapStore();

  map.activeTotalFireBanLGAs = hazardsStore?.filteredSectionHazards?.totalFireBans
    ?.filter((fireBan) => fireBan.isActive)
    .map((fireBan) => fireBan.rawLgaName);

  if (map.mapbox?.getLayer(MapboxLayer.totalFireBanPolygonsLayer)) {
    map.mapbox.setPaintProperty(MapboxLayer.totalFireBanPolygonsLayer, 'fill-color', [
      'case',
      ['in', ['get', 'name'], ['literal', map.activeTotalFireBanLGAs]],
      '#D6001C',
      '#939393',
    ]);
  }
  if (map.mapbox?.getLayer(MapboxLayer.totalFireBanMarkersLayer)) {
    map.mapbox?.setFilter(MapboxLayer.totalFireBanMarkersLayer, ['in', ['get', 'name'], ['literal', map.activeTotalFireBanLGAs]]);
  }
};
